import React from 'react'
import ListItemDetailed from '~/components/ListItemDetailed'
import Spinner from '~/components/Spinner'
import lazyLoad from "~/tools/lazy-load-images";
import { trackEvent } from "~/tools/analytics/cleverTap";
import { trackPageview } from "~/tools/analytics/googleAnalytics"
import {getResults, getLayout} from '~/redux/websearch/helper'
import { debounce, map } from 'lodash'
import './style.css'

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      searchResults: [],
      settings: {}
    };
  }

  componentDidMount() {
    this.searchInput.focus();

    getLayout("Search Screen").then(({ moduleList }) => {
      this.setState({ settings: moduleList[0].settings });
    });
  }

  componentDidUpdate() {
    if (!this.state.loading && this.state.searchTerm.length > 0) {
      var searchEventData = {
        keyword: this.state.searchTerm,
        platform: 'Web'
      }
      trackEvent('Searched', searchEventData);
      trackPageview(
        `/search?searchTerm=${this.state.searchTerm}`
      );
    }
    setTimeout(lazyLoad, 1000);
  }

  render() {
    const hasResults = this.state.totalResults > 0;
    return (
      <div className="searchList">
        <div
          className={"search-container " + (hasResults ? "has-results" : "")}
        >
          <span className="title">SEARCH List</span>
          <div className="search-input">
            <input
              type="text"
              className="search-container-input"
              placeholder="Search..."
              ref={input => {
                this.searchInput = input;
              }}
              onChange={debounce(e => this.handleKeyUp(e), 1000)}
            />
          </div>
        </div>
        {this.state.loading && <Spinner />}
        {!this.state.loading &&
          this.state.searchTerm.length > 0 && (
            <div className="search-results detailed-item-list">
              {hasResults ? (
                <div>
                  <div className="resultCount">Results ({this.state.totalResults})</div>
                  {this.renderResults()}
                </div>
              ) : (
                <div className="no-results"> Whoops, no matches were found .
Try a different term or <a href="/conceptLandingPage">browse the library</a>. </div>
              )}
            </div>
          )}
      </div>
    );
  }
  
  renderResults() {
    return map(this.state.searchResults, (item) => (
      <ListItemDetailed key={item.gist.id} showQueued={true} showBookmark={true} item={item} showPlayIcon={true}/>
    ));
  }

  handleKeyUp() {
    let searchTerm = this.searchInput.value;

    this.setState({ loading: !!searchTerm && searchTerm.length > 0 });
    getResults(searchTerm, 'video', true).then(r => {
        this.setState({
          loading: false,
          searchResults: r.data,
          searchTerm: searchTerm,
          totalResults: r.data.length
        });
    });
  }
}

export default View;
